var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.member && _vm.member.id)?_c('div',{staticClass:"member-orders"},[_c('headline',{staticClass:"mt-10"},[_vm._v(_vm._s(_vm.$t('onboarding.commissioning.member.button')))]),_c('member-equipment-orders',{attrs:{"member":_vm.member,"embedded":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }